<template>
    <modal :title="title" :show.sync="show" :close-show="true" height="auto" id="addAddr">
        <div slot="content">
            <div class="addr-form">
                <div class="form-control">
                    <label class="label-control">邮箱</label>
                    <input type="text" class="input-control" placeholder="请输入邮箱" v-model="contact.email" disabled>
                </div>
                <div class="form-control">
                    <label class="label-control">姓名</label>
                    <input type="text" class="input-control" placeholder="请输入姓名" maxlength="20" v-model="contact.nickname">
                </div>
                <div class="form-control checkbox-control">
                    <label class="label-control">分组</label>
                    <div class="checkboxs" v-bar>
                        <div>
                            <checkbox class="checkbox" v-model="contact.groups" v-for="group in groups" :key="group.id" :data="group.gid">&nbsp;{{group.groupname}}</checkbox>
                        </div>
                    </div>
                </div>
                <div class="form-control">
                    <label class="label-control"></label>
                    <div class="forms">
                        <a href="javascript:;" class="add-btn" v-if="!edit" @click="edit=true">
                            <i class="icons icon-add-plus-blue"></i> 添加分组
                        </a>
                        <div v-else>
                            <input type="text" class="input-control" v-model="groupName" @keyup.enter="addGroup">
                            <a href="javascript:;" class="btn-sure" @click.prevent="addGroup">确定</a>
                            <a href="javascript:;" class="btn-cancel" @click.prevent="undo">取消</a>
                        </div>
                    </div>
                </div>
                <div class="error-tip" v-if="!!errorInfo">
                    {{errorInfo}}
                </div>
            </div>
        </div>
        <div class="footer" slot="footer">
            <a href="javscript:void(0)" class="btn make-sure" @click.prevent="sure">确定</a>
            <a href="javscript:void(0)" class="btn cancel" @click.prevent="cancel">取消</a>
        </div>
    </modal>
</template>

<script type="text/javascript">
import $ from 'jquery'
import { checkbox } from '@/components/check'
import store from '@/store'
import { getWriteContact } from '@/service/contactService'
import { getHomeList, editContact, addGroup, getContactDetail } from '@/service/contactService'
export default {
    name: 'addAddr',
    data() {
        return {
            show: true,
            edit: false,
            groups: [],
            groupName: '',
            errorInfo: '',
            contact: {
                groups: [],
                nickname: '',
                email: '',
                aid: ''
            }
        }
    },
    async created() {
        this.contact.email = this.email
        this.contact.nickname = this.nickname
        this.contact.aid = this.gid
        this.groups = store.state.contact.groups
        if(this.gid) {
            this.contact = await getContactDetail(this.gid)
            this.contact.groups = this.contact.groups.map(g => g.id)
        }
    },
    components: {
        checkbox
    },
    methods: {
        close() {
            this.show = false
            this.$emit('update:show', false)
        },
        cancel() {
            if (this.onCancel) this.onCancel()
            this.close()
        },
        undo() {
            this.edit = false;
            this.errorInfo = '';
            this.groupName = ''
        },
        sure() {
            this.contact.nickname = $.trim(this.contact.nickname).length > 0 ? $.trim(this.contact.nickname) : $.trim(this.nickname)
            editContact(this.contact).then(res => {
                this.close()
                this.$toast({
                    theme: 'success',
                    message: (this.contact.aid ? '修改成功' : '新建成功')
                })
                store.dispatch('getContact')
                this.success && this.success(this.contact.nickname)
            }).catch(err => {
                this.$toast({
                    theme: 'danger',
                    message: '发生错误请重试'
                })
            })
        },
        addGroup() {
            if (this.groupName === '') {
                this.errorInfo = '组名不能为空'
                return
            }
            addGroup(this.groupName).then(async res => {
                store.dispatch('getContact')
                this.groups = (await getWriteContact()).groups
                this.edit = false
                this.groupName = ''
            }).catch(err => {
                this.errorInfo = err === 3511 ? '组已存在' : (err === 3516 ? '用户组数量达到上限' : '新建失败')
            })
        }
    },
    watch: {
        groupName() {
            this.errorInfo = ''
        }
    }
}
</script>

<style lang="scss">
.addr-form {
    text-align: left;
    width: 340px;
    margin: auto;
    padding-top: 20px;
    .form-control {
        height: 28px;
        line-height: 28px;
        margin-bottom: 10px;
        &.checkbox-control {
            height: auto;
            line-height: 1.5;
            margin-bottom: 0;
            .label-control {
                vertical-align: top;
            }
        }
        .checkboxs {
            display: inline-block;
            width: 300px;
            padding-right: 8px;
            color: #212126;
            font-weight: 400;
            > .vb-content {
                max-height: 74px;
                padding-bottom: 5px;
            }
        }
        .checkbox {
            display: inline-block;
            margin: 0 6px 5px 0;
            width: 90px;
            // overflow: hidden;
            // text-overflow:ellipsis;
            // white-space: nowrap;
            .label{
                color:#212126;
                display: inline-block;
                max-width: 72px;  
                padding-right: 3px; 
                // width: 72px;             
                overflow: hidden;
                text-overflow:ellipsis;
                white-space: nowrap;
                background: rgba(69,126,236,0.3);
                border-radius: 10px;
                margin-left:6px;
            }
        }
        .label-control {
            width: 36px;
            color:#84848B;        
            font-weight:500;    
            display: inline-block;
        }
        .input-control {
            border: 1px solid #d0d0d0;
            height: 28px;
            font-size: 12px;
            width: 300px;
            padding: 0 8px;
        }
    }
    .error-tip {
        height: 30px;
        line-height: 30px;
        margin: -10px 0 0 40px;
        font-size: 12px;
        color: #ea0a00;
    }
    .forms {
        display: inline-block;
        > div {
            font-size: 0;
            width: 300px;
            height: 28px;
            line-height: 28px;
            overflow: hidden;
            border: 1px solid #d0d0d0;
            > a {
                font-size: 12px;
                margin-right: 10px;
                color: black;
                &.btn-sure {
                    color: #0f409f;
                }
            }
            .input-control {
                font-size: 12px;
                width: 226px;
                border: none;
            }
        }
    }
    .add-btn {
        color: #457eec;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/modal/addAddr.vue